import { useEffect, useState } from "react";
import { useApi } from "./useApi";
import { useCompanyId } from "./useCompanyId";
import { pascalCase } from "../utils/textUtils";

const ALL_OPTION = { value: "", label: "All" };

export function useDeflectionProcessors(): { value: string; label: string }[] {
  const { get } = useApi();
  const { companyId } = useCompanyId();
  const [options, setOptions] = useState([ALL_OPTION]);

  useEffect(() => {
    const query = companyId ? `?companyId=${companyId}` : "";
    get<{ processors: string[] }>(`/api/deflections/processors${query}`)
      .then((res) => {
        setOptions([
          ALL_OPTION,
          ...res.processors.map((p) => ({ value: p, label: pascalCase(p) })),
        ]);
      })
      .catch((err) => console.error("Failed to fetch processors:", err));
  }, [get, companyId]);

  return options;
}
